import { getToken, returnError } from './helperFunc';
import {
    getProfitLossAction,
    addProfitLossAction,
    editProfitLossAction,
    deleteProfitLossAction,
} from './requestEndpoints';

const SET_PROFIT_LOSS_LOADING = 'SET_PROFIT_LOSS_LOADING';
const CLEAR_PROFIT_LOSS_ERROR = 'CLEAR_PROFIT_LOSS_ERROR';

const GET_PROFIT_LOSS_SUCCESS = 'GET_PROFIT_LOSS_SUCCESS';
const GET_PROFIT_LOSS_FAIL = 'GET_PROFIT_LOSS_FAIL';

const ADD_PROFIT_LOSS_SUCCESS = 'ADD_PROFIT_LOSS_SUCCESS';
const ADD_PROFIT_LOSS_FAIL = 'ADD_PROFIT_LOSS_FAIL';

const EDIT_PROFIT_LOSS_SUCCESS = 'EDIT_PROFIT_LOSS_SUCCESS';
const EDIT_PROFIT_LOSS_FAIL = 'EDIT_PROFIT_LOSS_FAIL';

const DELETE_PROFIT_LOSS_SUCCESS = 'DELETE_PROFIT_LOSS_SUCCESS';
const DELETE_PROFIT_LOSS_FAIL = 'DELETE_PROFIT_LOSS_FAIL';

const CLEAR_REMOVED_FLAG = 'CLEAR_REMOVED_FLAG';

export const getProfitLoss = ({ operatorId, outletId, year, month }) => async (dispatch, getState) => {
    try {
        dispatch({ type: CLEAR_PROFIT_LOSS_ERROR });
        dispatch({ type: SET_PROFIT_LOSS_LOADING });

        const { user } = getState();
        const token = getToken(user);

        const { data } = await getProfitLossAction(operatorId, outletId, year, month, token);

        dispatch({ type: GET_PROFIT_LOSS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: GET_PROFIT_LOSS_FAIL, payload: returnError(error) });
    }
};

export const addProfitLoss = (newProfitLoss) => async (dispatch, getState) => {
    try {
        dispatch({ type: CLEAR_PROFIT_LOSS_ERROR });
        dispatch({ type: SET_PROFIT_LOSS_LOADING });

        const { user } = getState();
        const token = getToken(user);

        await addProfitLossAction(newProfitLoss, token);

        dispatch({ type: ADD_PROFIT_LOSS_SUCCESS });
    } catch (error) {
        dispatch({ type: ADD_PROFIT_LOSS_FAIL, payload: returnError(error) });
    }
};

export const editProfitLoss = (updateData) => async (dispatch, getState) => {
    try {
        dispatch({ type: CLEAR_PROFIT_LOSS_ERROR });
        dispatch({ type: SET_PROFIT_LOSS_LOADING });

        const { user } = getState();
        const token = getToken(user);

        await editProfitLossAction(updateData, token);

        dispatch({ type: EDIT_PROFIT_LOSS_SUCCESS });
    } catch (error) {
        dispatch({ type: EDIT_PROFIT_LOSS_FAIL, payload: returnError(error) });
    }
};

export const deleteProfitLoss = (deleteData) => async (dispatch, getState) => {
    try {
        dispatch({ type: CLEAR_PROFIT_LOSS_ERROR });
        dispatch({ type: SET_PROFIT_LOSS_LOADING });

        const { user } = getState();
        const token = getToken(user);

        await deleteProfitLossAction(deleteData, token);

        dispatch({ type: DELETE_PROFIT_LOSS_SUCCESS });
    } catch (error) {
        dispatch({ type: DELETE_PROFIT_LOSS_FAIL, payload: returnError(error) });
    }
};

export const clearRemovedFlag = () => ({ type: CLEAR_REMOVED_FLAG });

export const clearProfitLossError = () => ({ type: CLEAR_PROFIT_LOSS_ERROR });

const initialState = {
    profitLossList: [],
    loading: false,
    created: false,
    removed: false,
    error: null,
};

export const profitLossSettingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PROFIT_LOSS_LOADING:
            return {
                ...state,
                loading: true,
                created: false,
                removed: false,
                error: null,
            };

        case CLEAR_PROFIT_LOSS_ERROR:
            return {
                ...state,
                error: null,
            };

        case GET_PROFIT_LOSS_SUCCESS:
            return {
                ...state,
                loading: false,
                profitLossList: action.payload.data,
            };

        case ADD_PROFIT_LOSS_SUCCESS:
            return {
                ...state,
                loading: false,
                created: true,
            };

        case EDIT_PROFIT_LOSS_SUCCESS:
            return {
                ...state,
                loading: false,
            };

        case DELETE_PROFIT_LOSS_SUCCESS:
            return {
                ...state,
                loading: false,
                removed: true,
            };

        case GET_PROFIT_LOSS_FAIL:
        case ADD_PROFIT_LOSS_FAIL:
        case EDIT_PROFIT_LOSS_FAIL:
        case DELETE_PROFIT_LOSS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case CLEAR_REMOVED_FLAG:
            return {
                ...state,
                removed: false,
                created: false,
            };

        default:
            return state;
    }
};